const extensionsPermeses = ['.gif', '.jpg', '.jpeg', '.png', '.bmp'];
const tipusImatgePermesos = ['image/gif', 'image/jpeg', 'image/png','image/bmp'];

export const extensionsPermesesEnString = extensionsPermeses.join();

export const fitxerTipusNoPermes = (tipusFitxer) => {
    return !tipusImatgePermesos.includes(tipusFitxer);
};



// WEBPACK FOOTER //
// ./src/commons/gestioImatges.js